export const primaryNavLinks = [
  { href: "/", label: "Home" },
  { href: "/front-mate/", label: "Front Mate" },
  { href: "/about", label: "About" },
  { href: "/blogs", label: "Blogs" },
  { href: "/contact-us", label: "Contact" },
  { href: "/privacy-policy", label: "Privacy Policy" },
] as const;

export const navLinkClassName =
  "whitespace-nowrap text-[15px] font-medium leading-none text-slate-600 transition-colors hover:text-harbor focus:outline-none focus-visible:ring-2 focus-visible:ring-harbor/20";
